const actions = {
  //Listar Alertas
  listarAlertas: async (context) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.get(`alert/from-logged-in-user`);

    return response;
  },

  desativarAtivarAlerta: async (
    context,
    { action, notification_id, optin }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.put(`alert/${action}/${notification_id}`, {
      optin,
    });

    return response;
  },
  getLogs: async (
    context,
    {
      per_page,
      page,
      current_page,
      action,
      resource_id,
      resource_name,
      level,
      user_id,
      user_name,
      data_inicial,
      data_final,
    }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.get(`log`, {
      params: {
        page,
        current_page,
        resource_id,
        action,
        per_page,
        resource_name,
        level,
        user_id,
        user_name,
        data_inicial,
        data_final,
      },
    });

    return response;
  },

  getLogsNotificacao: async (
    context,
    { page, current_page, data_inicial, data_final, pessoa, notificacao }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.get(`alert/relatorio/notificacoes-enviadas`, {
      params: {
        page,
        current_page,
        data_inicial,
        data_final,
        pessoa,
        notificacao,
      },
    });

    return response;
  },
  // Obter Logs de Planilhas
  getLogsPlanilhas: async (
    context,
    {
      per_page,
      page,
      id,
      mapeamento,
      acao,
      url,
      created_at,
      matricula,
      usuario_id,
      usuario_nome,
      role,
      data_inicial,
      data_final,
    }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.get(`manutencao-planilha/buscar-log-planilha`, {
      params: {
        per_page,
        page,
        id,
        mapeamento,
        acao,
        url,
        created_at,
        usuarioMatricula: matricula,
        usuarioNome: usuario_nome,
        usuarioId: usuario_id,
        role,
        dataInicio: data_inicial,
        dataFinal: data_final,
      },
    });
    return response;
  },
};

export const configuracao = {
  namespaced: true,
  actions,
};
